import { Step, StepValidationState } from "../../../../../interfaces/step";
import { Stepper } from "../../../../../interfaces/stepper";
import { DebtorsComponent } from "../../../../orders/debtors/debtors.component";
import { SecuredPartiesComponent } from "../../../../orders/secured-parties/secured-parties.component";
import { ReviewComponent } from "projects/reg-hub-client/src/app/orders/review/review.component";
import { CollateralComponent } from "projects/reg-hub-client/src/app/orders/collateral/collateral.component";
import { ONLienDetailsComponent } from "projects/reg-hub-client/src/app/orders/lien-details/on-lien-details/on-lien-details.component";
import { RegisteringAgentComponent } from "projects/reg-hub-client/src/app/orders/registering-agent/registering-agent.component";
import { OrderChangesComponent } from "projects/reg-hub-client/src/app/orders/order-changes/order-changes.component";
import { ConfigurationState } from "reg-hub-common";

export class ONAmendmentStepper implements Stepper {

    steps: Step[];

    constructor(configurationState: ConfigurationState) {
        this.steps = [
            { title: "Details", content: ONLienDetailsComponent, validationState: StepValidationState.DefaultState },
            { title: "Debtors", content: DebtorsComponent, validationState: StepValidationState.DefaultState },
            { title: "Sec. Parties", content: SecuredPartiesComponent, validationState: StepValidationState.DefaultState },
            ...(
                configurationState.shouldShowRegisteringAgentTab()
                    ? [{ title: "Agent", content: RegisteringAgentComponent, validationState: StepValidationState.DefaultState }]
                    : []
            ),
            { title: "Collateral", content: CollateralComponent, validationState: StepValidationState.DefaultState },
            { title: "Changes", content: OrderChangesComponent, validationState: StepValidationState.DefaultState },
            { title: "Review", content: ReviewComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}